export default {"src":"/_next/static/media/account-orders-icon.c60f7244.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};